import { Controller } from "@hotwired/stimulus";
import { seemsOffline } from "../utils/connectivity";
import { isPwaEnabled } from "../utils/offline_gating";

export default class extends Controller {
  static targets = ["card", "nextBtn", "prevBtn", "toHonorCode", "todoDropdown"];

  connect() {
    this.currentCardIndex = 0;

    if (this.cardTargets.length > 0) {
      this.cardTargets[this.currentCardIndex].classList.add('active');
    }

    if (!isPwaEnabled()) return;

    this.boundEnforceConnectivity = () => this.redirectIfOffline();
    this.boundBlockSubmit = (event) => {
      if (!this.redirectIfOffline()) return;
      event.preventDefault();
      event.stopPropagation();
    };
    window.addEventListener('offline', this.boundEnforceConnectivity);
    this.element.addEventListener('submit', this.boundBlockSubmit, true);
    this.redirectIfOffline();
  }

  disconnect() {
    if (this.boundEnforceConnectivity) {
      window.removeEventListener('offline', this.boundEnforceConnectivity);
    }
    if (this.boundBlockSubmit) {
      this.element.removeEventListener('submit', this.boundBlockSubmit, true);
    }
  }

  redirectIfOffline() {
    if (!isPwaEnabled() || !seemsOffline()) return false;
    const modal = document.querySelector('[data-offline-navigation-target="featureUnavailableModal"]');
    if (modal) {
      modal.classList.remove("hidden");
      modal.classList.add("gen-modal--front");
    }
    return true;
  }

  goToNextCard() {
    if (this.redirectIfOffline()) return;
    if (this.currentCardIndex < this.cardTargets.length - 1) {
      this.cardTargets[this.currentCardIndex].classList.remove('active');
      this.currentCardIndex++;
      this.cardTargets[this.currentCardIndex].classList.add('active');
    }
  }

  goToPreviousCard() {
    if (this.redirectIfOffline()) return;
    if (this.currentCardIndex > 0) {
      this.cardTargets[this.currentCardIndex].classList.remove('active');
      this.currentCardIndex--;
      this.cardTargets[this.currentCardIndex].classList.add('active');
    }
  }

  skipAssessment() {
    if (this.redirectIfOffline()) return;
    this.currentCardIndex = this.cardTargets.length - 1; // Jump to last card
    this.cardTargets.forEach(card => card.classList.remove('active')); // Hide all cards
    this.cardTargets[this.currentCardIndex].classList.add('active');
  }

  toggleDropdown(event) {
    if (this.redirectIfOffline()) return;
    let dropdownContainer = this.todoDropdownTarget;
    dropdownContainer.classList.toggle("hidden", event.target.value !== "true");
    document.getElementById("autoAddTodosField").value = event.target.value === "true";
    document.getElementById('toHonorCode').disabled = event.target.value === "true";

  }

  honorSubmit() {
    document.getElementById('honorCodeCheckbox').addEventListener('change', function () {
      document.getElementById('nextButton').disabled = !this.checked;
    });
  }

  toggleMultiSelect() {
    if (this.redirectIfOffline()) return;
    // Toggle visibility of the multi-select dropdown
    document.getElementById("todoListDropdown").classList.toggle("hidden");
  }

  updateSelectedLists() {
    if (this.redirectIfOffline()) return;
    const selectedIds = Array.from(document.querySelectorAll("input[name='todo_list_ids[]']:checked")).map(checkbox => checkbox.value);
    const newListName = document.getElementById("newTodoListName").value.trim();

    // Update hidden fields
    document.getElementById("todoListIdsField").value = selectedIds.join(',');
    document.getElementById("newTodoListField").value = newListName;

    // Enable submit button if at least one list is selected or a new list is created
    document.getElementById("toHonorCode").disabled = selectedIds.length === 0 && newListName === "";
  }

  toggleNewListInput(event) {
    if (this.redirectIfOffline()) return;
    document.getElementById("newTodoListName").classList.toggle("hidden", !event.target.checked);
    if (!event.target.checked) {
      document.getElementById("newTodoListName").value = "";
    }
    this.updateSelectedLists();
  }

}
